import { tracker } from '@openreplay/tracker';
import trackerMobX from '@openreplay/tracker-mobx';

import { getEnvironment } from '@/common/helpers/getEnvironment';
import config from '@/config';

export function enableOpenreplay() {
  const env = getEnvironment();

  if (env === 'local') {
    return;
  }

  tracker.configure({
    projectKey: config.OPENREPLAY_KEY,
    ingestPoint: config.OPENREPLAY_URL,
    canvas: {
      disableCanvas: true,
    },
  });
  tracker.use(
    trackerMobX({
      update: true,
      add: true,
      delete: true,
      predicate: () => true,
      sanitize: (event) => event,
    }),
  );
  tracker.start();
}
